import React from 'react';
import { ChevronDownIcon, EyeIcon, MessageCircleIcon, CopyIcon } from 'lucide-react';
import { JobsTable } from '../../dashboard/JobsTable';
import { JobMessageButton } from '../../messaging/JobMessageButton';
interface InProgressJobsProps {
  jobs: any[];
  onViewDetails?: (jobId: string) => void;
  onMessageForeman?: (jobId: string) => void;
  onCreateSimilarJob?: (jobId: string) => void;
}
export const InProgressJobs = ({
  jobs,
  onViewDetails,
  onMessageForeman,
  onCreateSimilarJob
}: InProgressJobsProps) => {
  const columns = [{
    key: 'jobName',
    header: 'JOB NAME',
    sortable: true
  }, {
    key: 'jobNumber',
    header: 'JOB #',
    sortable: true
  }, {
    key: 'location',
    header: 'LOCATION',
    sortable: true
  }, {
    key: 'foreman',
    header: 'FOREMAN',
    sortable: true,
    render: (job: any) => <div className="flex items-center gap-2" data-id="element-1931">
          {job.foreman}
          <JobMessageButton jobId={job.id} jobName={job.jobName} recipientRole="foreman" buttonText="" className="text-purple-600 hover:text-purple-800" data-id="element-1932" />
        </div>
  }, {
    key: 'tonnageProgress',
    header: 'TONNAGE PROGRESS',
    sortable: true
  }];
  const actions = [{
    label: 'View Details',
    onClick: (id: string) => onViewDetails?.(id),
    color: 'bg-blue-500 hover:bg-blue-600',
    icon: <EyeIcon size={16} data-id="element-1933" />
  }, {
    label: 'Message Foreman',
    onClick: (id: string) => onMessageForeman?.(id),
    color: 'bg-purple-500 hover:bg-purple-600',
    icon: <MessageCircleIcon size={16} data-id="element-1934" />
  }, {
    label: 'Create Similar Job',
    onClick: (id: string) => onCreateSimilarJob?.(id),
    color: 'bg-green-500 hover:bg-green-600',
    icon: <CopyIcon size={16} data-id="element-1935" />
  }];
  return <div className="bg-white rounded-md shadow overflow-hidden mt-4" data-id="element-1936">
      <div className="p-4" data-id="element-1937">
        <JobsTable columns={columns} data={jobs} actions={actions} filters={true} data-id="element-1938" />
      </div>
    </div>;
};